import { useEffect, useState } from 'react';

export type PredicateFn<Item = any, Value = any> = (value: Value, item: Item) => boolean;
type ItemNameToPredicate = Record<string, PredicateFn>;

type FilterObject = Record<string, any>;

interface Props<T> {
	data: T[];
	initialFilterObject?: FilterObject;
	predicatesByKey: ItemNameToPredicate;
}

function filterFromAllPredictors<T>(data: T[], predicatesByKey: ItemNameToPredicate, filterObject: FilterObject) {
	const filterEntries = Object.entries(filterObject);

	// No input has value
	if (!filterEntries.length) {
		return data;
	}

	return data.filter(item =>
		filterEntries.every(([filterName, filterValue]) => {
			// If no predicate for that field than ignore it
			if (!predicatesByKey[filterName]) {
				return true;
			}

			return predicatesByKey[filterName](filterValue, item);
		})
	);
}

const useFilter = <T>({ data, initialFilterObject, predicatesByKey }: Props<T>) => {
	const [filterObject, setFilterObject] = useState<FilterObject>(() => initialFilterObject);
	const [filteredData, setFilteredData] = useState<T[]>(data);

	useEffect(() => {
		setFilteredData(filterFromAllPredictors(data, predicatesByKey, filterObject));
	}, [filterObject, data]);

	return {
		setFilterObject,
		filteredData
	};
};

export default useFilter;
